<template>
  <div
    v-if="show"
    class="map-notice map-notice--bottom map-notice--pulse"
  >
    <div class="map-notice__content">
      <theme-icon icon="zoom-search-icon" type="icons" class="map-notice__icon" />
      <span class="map-notice__text">Must Zoom In More</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZoomNotice',
  
  props: {
    /**
     * Whether to show the zoom notice
     */
    show: {
      type: Boolean,
      required: true
    }
  }
};
</script>
